import html2pdf from 'html2pdf.js';

export const generatePDF = (html: string, fileName: string) => {
  const element = document.createElement('div');
  element.innerHTML = html;

  const options = {
    margin: 10,
    filename: fileName,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: {
      mode: ['avoid-all', 'css', 'legacy'],
    },
  };

  html2pdf().set(options).from(element).save();
};
